import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faStreetView } from '@fortawesome/free-solid-svg-icons';
import { MapContainer, TileLayer, Marker,Popup } from 'react-leaflet';
import moment from 'moment/moment';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';

//Assets
import { iconeNormal } from '../../assets/Icons/Icons';

//Api
import ramoDeAtividade_api from '../../api/ramoDeAtividade_api';
import rotaColeta_api from '../../api/rotaColeta_api'
import modalidadeColeta_api from '../../api/modalidadeColeta_api';
import mapasService_api from '../../api/mapasService_api';

//Helpers
import { showMessage } from '../../helpers/message';

//Context
import { useAuth } from '../../context/auth';

//Shared
import FiltroPrefeitura from 'views/Shared/FiltroPrefeitura';
import { MAPA_TILE_URL, MAPA_TILE_ATTRIBUTION } from '../../helpers/mapas';


//Estado inicial dos filtros do mapa
function initialStateFiltros() {
    const dataFinal = new Date();
    const dataInicial = new Date();
    dataInicial.setDate(dataInicial.getDate() - 1);
    return {
        rotaColetaId: 0,
        rotaColetaId_selected: null,
        modalidadesIds: [],
        modalidadesIds_selected: [],
        ramoAtividadeIds: [],
        ramoAtividadeIds_selected: [],
        prefeituraId: 0,
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD")
    }
}

export default function ColetasProgramadas() {
    const { setupVariavel } = useAuth();

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);
    const handlePrefeitura = (value) => {
        //salva o id da prefeitura nos filtros
        setFiltros({
            ...filtros,
            prefeituraId: value
        })

        setPrefeitura_Id(value);
        //Pegando as coletas programadas iniciais
        carregaColetasProgramadas(value);
    }
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de controle do mapa
    const [map, setMap] = useState(null);
    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);
    //Estado de controle da visualização dos campos de filtros
    const [openFiltros, setOpenFiltros] = useState(false);
    //Estado de controle da visão de sateleti
    const [viewSatelite, setViewSatelite] = useState(() => false);
    //Função de troca do estado de visão de sateleti
    const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);
    //Função que faz a troca de estado da visualização dos filtros
    const toggleFiltros = () => setOpenFiltros(!openFiltros);
    //Estado que guarda os pontos das coletas programadas
    const [coletasProgramadas, setColetasProgramadas] = useState([]);
    //Estado de controle das opções de modalidades de coleta
    const [modalidadesDeColeta, setModalidadesDeColeta] = useState([]);
    //Estado de controle das opções de ramos de atividades
    const [ramosDeAtividade, setRamosDeAtividade] = useState([]);
    //Estado de controle das opções de rotas de coletas
    const [rotasDeColetas, setRotasDeColetas] = useState([]);
    //Estado de controle do ponto central do mapa
    const [location, setLocation] = useState([-23.2198396, -45.8915658]);
    //onChange para os campos de multi select
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        })
    }
    //onChange para os multiSelects
    const onChangeMultiSelect = (e, select) => {
        const { name } = select;
        const ids = e.map(op => op.value);
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: ids
        })
    }
    //onChange para os campos de data
    const onChangeData = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }
    //Função que carrega as coletas programadas
    const carregaColetasProgramadas = (prefeituraId = null) => {
        setLoading(true);
        const _filtros = { ...filtros };
        if (prefeituraId) {
            _filtros.prefeituraId = prefeituraId;
        }
        mapasService_api.ColetasProgramadas(_filtros).then(response => {
            setColetasProgramadas(response.data);

        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    //Carrega os valores dos filtros de select
    useEffect(() => {
        setLoading(true);

        if(setupVariavel?.coordenadaPrefeitura){
            const [latitude, longitude] = setupVariavel?.coordenadaPrefeitura.split(";");
            setLocation([parseFloat(latitude), parseFloat(longitude)])
        }

        modalidadeColeta_api.GetModalidadesPorTransportador().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            })
            setModalidadesDeColeta(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null));
        rotaColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao }
            });
            setRotasDeColetas(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        });
        ramoDeAtividade_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            })
            setRamosDeAtividade(response.data);
        })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
        carregaColetasProgramadas();

    }, []);
    return (
        <MainCard noCard title={"Coletas Programadas"} btnFiltros={toggleFiltros}>
            {loading && <Loading />}
            <div className={`filtros ${openFiltros ? "" : "close"}`} id={"filtros"}>
                <Row>
                    <Col md={"12"} lg="12">
                        <TextField label="Rota desejada" name={"rotaColetaId_selected"} value={filtros.rotaColetaId_selected} onChange={onChangeSelected} searchable type={"select"} options={rotasDeColetas} />
                    </Col>
                    <Col md={"12"} lg="12">
                        <TextField label="Modalidade de coleta" multiple name={"modalidadesIds_selected"} value={filtros.modalidadesIds_selected} onChange={onChangeMultiSelect} type={"select"} options={modalidadesDeColeta} />
                    </Col>
                    <Col md={"12"} lg="12">
                        <TextField label="Ramo de atividade" multiple name={"ramoAtividadeIds_selected"} value={filtros.ramoAtividadeIds_selected} onChange={onChangeMultiSelect} type={"select"} options={ramosDeAtividade} />
                    </Col>
                </Row>
                <Row>
                    <Col md={"12"} lg="4">
                        <TextField label="Data inicial" name={"dataInicial"} value={filtros.dataInicial} onChange={onChangeData} type={"date"} />
                    </Col>
                    <Col md={"12"} lg="4">
                        <TextField label="Data final" name={"dataFinal"} value={filtros.dataFinal} onChange={onChangeData} type={"date"} />
                    </Col>
                    <Col md={"12"} lg="4" className='h-100 mt-4'>
                        <Button color='info' style={{ color: "#fff" }} className={"mt-1 w-100"} onClick={() => carregaColetasProgramadas()}> <FontAwesomeIcon icon={faSearch} className={"me-2"} /> Pesquisar</Button>
                    </Col>
                </Row>
            </div>
            <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
            <Row style={{ height: "65vh", backgroundColor: "#eee" }} className="mt-3 rounded-3 overflow-hidden shadow" >
                <Col md="12" lg="12" className=' m-0 p-0'>
                    {loading ? <></> :
                        <MapContainer
                            center={location}
                            zoom={13}
                            ref={setMap}
                            whenCreated={mapState => {
                                setMap(mapState)
                            }}

                            style={{ height: "100%", width: "100%", backgroundColor: "#333" }}
                        >
                            <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>
                            <TileLayer
                                url={MAPA_TILE_URL}
                                attribution={MAPA_TILE_ATTRIBUTION}
                            />
                            {
                                viewSatelite
                                &&
                                <TileLayer
                                    url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                                    maxZoom={20}
                                    subdomains={['mt1', 'mt2', 'mt3']}
                                />

                            }



                            {coletasProgramadas && coletasProgramadas.map((value, index) => {

                                return (
                                    <Marker key={index} icon={iconeNormal} position={[value.latitude, value.longitude]}
                                        eventHandlers={{
                                            click: (e) => {
                                                setLocation(e.latlng);
                                                map.flyTo(e.latlng);
                                            },
                                        }}
                                    >
                                        <Popup className='popup-leaflet'> <p className=' text-secondary fw-bold'>Identificação: {value.identificacao} </p></Popup>
                                    </Marker>
                                )
                            })}
                        </MapContainer>
                    }
                </Col>
            </Row>
        </MainCard>
    )
}